import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "pt-10 px-10 screen:pb-10 screen:bg-[#f0f0f1]" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "text-2xl text-center" }, "Statistik: Mit Liv - min sundhed appen", -1)
const _hoisted_3 = { class: "print:hidden space-x-10 border-b flex border-gray-400" }
const _hoisted_4 = { class: "w-16" }
const _hoisted_5 = { class: "w-22" }
const _hoisted_6 = {
  key: 0,
  class: "w-40"
}
const _hoisted_7 = {
  key: 1,
  class: "w-28"
}
const _hoisted_8 = {
  key: 2,
  class: "w-40"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("a", {
  class: "text-xl leading-10 focus:outline-none whitespace-nowrap",
  target: "_blank",
  href: "/public-statistics"
}, "Offentlig side ", -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "pt-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("nav", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          class: _normalizeClass([{ 'border-b-4 border-black font-medium': _ctx.currentTabIndex === 0 }, "text-xl leading-10 focus:outline-none"]),
          type: "button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.currentTabIndex = 0))
        }, "Forløb", 2)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("button", {
          class: _normalizeClass([{ 'border-b-4 border-black font-medium': _ctx.currentTabIndex === 1 }, "text-xl leading-10 focus:outline-none"]),
          type: "button",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.currentTabIndex = 1))
        }, "Brugsdata", 2)
      ]),
      (!_ctx.isPublic)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("button", {
              class: _normalizeClass([{ 'border-b-4 border-black font-medium': _ctx.currentTabIndex === 2 }, "text-xl leading-10 focus:outline-none"]),
              type: "button",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.currentTabIndex = 2))
            }, " Partnerkommuner ", 2)
          ]))
        : _createCommentVNode("", true),
      (!_ctx.isPublic)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("button", {
              class: _normalizeClass([{ 'border-b-4 border-black font-medium': _ctx.currentTabIndex === 3 }, "text-xl leading-10 focus:outline-none"]),
              type: "button",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.currentTabIndex = 3))
            }, "Indstillinger", 2)
          ]))
        : _createCommentVNode("", true),
      (!_ctx.isPublic)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_11, [
      (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.currentTab.component)))
    ])
  ]))
}